import { render, staticRenderFns } from "./EnableTwoFactorAuth.vue?vue&type=template&id=a3b94330&scoped=true"
import script from "./EnableTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./EnableTwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./EnableTwoFactorAuth.vue?vue&type=style&index=0&id=a3b94330&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b94330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b94330')) {
      api.createRecord('a3b94330', component.options)
    } else {
      api.reload('a3b94330', component.options)
    }
    module.hot.accept("./EnableTwoFactorAuth.vue?vue&type=template&id=a3b94330&scoped=true", function () {
      api.rerender('a3b94330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/user/EnableTwoFactorAuth.vue"
export default component.exports